import { Typography } from '@mui/material'
import { RpcError } from '@protobuf-ts/runtime-rpc'
import { C1Alert, C1AlertTitle } from 'c1ui'
import { APIError, APIMetaDataArray } from 'components/core/errors/api'
import { C1Link } from 'components/core/links/C1Link'
import { routes } from 'lib/routes'
import { codeToString } from 'lib/rpc'
import { TaskRef } from 'pbts/c1/api/task/v1/task'
import { Any } from 'pbts/google/protobuf/any'
import { Code } from 'pbts/google/rpc/code'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

export const TaskAPIError: React.FC<{ err: RpcError; title: ReactNode; noAlert?: boolean }> = ({ err, title, noAlert = false }) => {
    if (err === null || err === undefined) {
        return null
    }

    if (err.code !== codeToString(Code.ALREADY_EXISTS)) {
        return <APIError title={title} err={err} />
    }

    const data = APIMetaDataArray(err).find((d) => Any.typeUrlToName(d.typeUrl || '') === TaskRef.typeName)
    const taskRef = data ? Any.unpack<TaskRef>(data, TaskRef) : null
    if (!taskRef) {
        return <APIError title={title} err={err} />
    }

    const duplicateRequestTitle = (
        <C1AlertTitle>
            <FormattedMessage
                id="task_already_exists_title"
                defaultMessage="Duplicate request found"
            />
        </C1AlertTitle>
    )

    const duplicateRequestBody = (
        <Typography sx={{ mt: 1 }}>
            <FormattedMessage
                id="task_already_exists_body"
                defaultMessage="You can view the progress of the existing task <link>here</link>."
                values={{
                    link: (chunks) => <C1Link href={routes.task(taskRef.id)}>{chunks}</C1Link>,
                }}
            />
        </Typography>
    )

    if (noAlert) {
        return (
            <>
                {duplicateRequestTitle}
                {duplicateRequestBody}
            </>
        )
    }

    return (
        <C1Alert severity="primary">
            {duplicateRequestTitle}
            {duplicateRequestBody}
        </C1Alert>
    )
}
